module.exports = __webpack_public_path__ + "img/img_product_mobile_customer.1398bc06.jpg";